var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 250",
    style: {
      enableBackground: "new 0 0 250 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DE1427;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 19.44,
    y: 156.83,
    className: "st0",
    width: 212.18,
    height: 22.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242.51,71H8.22c-3.16,0-5.73,2.56-5.73,5.73v96.55c0,3.16,2.56,5.73,5.73,5.73h234.29 c3.16,0,5.73-2.56,5.73-5.73V76.73C248.23,73.56,245.67,71,242.51,71z M99.97,130.81V116c0-0.7,0.7-1.27,1.57-1.27h49.68 c0.87,0,1.57,0.57,1.57,1.27v14.81c0,0.7-0.7,1.27-1.57,1.27h-49.68C100.68,132.08,99.97,131.51,99.97,130.81z M181.59,75.47h52.47 v1.76h-52.47V75.47z M181.59,79.06h52.47v3h-52.47V79.06z M126.89,75.47h51.65v1.76h-51.65V75.47z M126.89,79.06h51.65v3h-51.65 V79.06z M72.19,75.47h51.65v1.76H72.19V75.47z M72.19,79.06h51.65v3H72.19V79.06z M16.67,75.47h52.47v1.76H16.67V75.47z  M16.67,79.06h52.47v3H16.67V79.06z M7.37,176.98c-1.26-1.51-2.07-3.72-2.07-6.22V79.23c0-2.58,0.86-4.85,2.19-6.36 c2.31,14.03,4.91,16.26,4.91,42.61c0,5.38-0.14,10.7-0.37,15.89c-0.05,1.31-0.16,3.48-0.26,5.09 C10.83,152.51,9.02,166.89,7.37,176.98z M236.18,178H14.54v-26.12h221.64V178z M245.42,170.77c0,2.5-0.81,4.71-2.07,6.22 c-1.65-10.09-3.46-24.48-4.39-40.52c-0.07-1.97-0.18-4.09-0.26-5.09c-0.23-5.19-0.37-10.5-0.37-15.89 c0-26.35,2.59-28.58,4.91-42.61c1.33,1.51,2.19,3.78,2.19,6.36V170.77z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcIcon);
export default __webpack_public_path__ + "static/media/ac_icon.a4dd97288526df61a5cc812a9486a38e.svg";
export { ForwardRef as ReactComponent };